import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { JiraUsersComponent } from 'src/app/user/jira-users/jira-users.component';
import { NavigationService } from './service/navigation.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {
  user: any
  errorCount: number;
  public jiraUsersModalRef: any;

  constructor(public navigationService: NavigationService, private readonly modalService: NgbModal) {
    this.navigationService.errorCount$.subscribe((res) => (this.errorCount = res));
  }

  ngOnInit(): void {
    const userData = globalThis.localStorage.getItem(LocalStorageKeyEnum.USER);
    this.user = userData ? JSON.parse(userData) : { photoUrl: "" };

    if (this.user?.picture) {
      this.user.photoUrl = this.user.picture.split('=')[0] + '=s512-c';
    } else if (!this.user.photoUrl) {
      this.user.photoUrl = "";
    }

    const roleData = globalThis.localStorage.getItem(LocalStorageKeyEnum.ROLE);
    const roleObj = roleData ? JSON.parse(roleData) : null;
    const currentRole = roleObj?.role?.toLowerCase();

    if (currentRole === 'atlassian_user_manager') {
      this.openJiraUsersModal();
    } else {
      this.fetchErrors();
    }
  }

  fetchErrors() {
    this.navigationService.getErrorCount();
  }

  openJiraUsersModal() {
    this.jiraUsersModalRef = this.modalService.open(JiraUsersComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'jira-users-modal',
      backdropClass: 'jira-users-backdrop',
    });
    this.jiraUsersModalRef.componentInstance.modalRef = this.jiraUsersModalRef;
  }
}
